// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResumeEnhancement.css - UPDATED WITH LIGHT THEME */

/* --- Add these Button Styles to ResumeEnhancement.css --- */

/* Base style for primary buttons (Red Gradient) */

.page-container {
  /* Ensure the light theme gradient is applied */
  background: var(--gradient-hero);
  /* Keep other necessary styles like padding-top */
  padding-top: var(--navbar-height);
  min-height: calc(100vh - var(--navbar-height));
  padding-bottom: 4rem; /* Ensure consistent bottom padding */
}

.submit-button {
  background: var(--gradient-button); /* Red gradient */
  color: var(--text-on-gradient); /* White text */
  padding: 0.75rem 1.5rem; /* Match Auth button padding */
  font-size: 1rem; /* Match Auth button font size */
  font-weight: 600;
  border: none;
  border-radius: var(--border-radius-full); /* Fully rounded */
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  text-align: center; /* Ensure text is centered */
  min-width: 150px; /* Give buttons a minimum width */
}

.submit-button:hover:not(:disabled) {
  box-shadow: var(--shadow-button-hover); /* Reddish hover shadow */
  transform: scale(1.03); /* Slight scale effect */
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Secondary Button Style (Gray border, dark text) */
.submit-button.secondary {
  background: transparent;
  border: 1px solid var(--border-primary); /* Light gray border */
  color: var(--text-primary); /* Dark text */
  box-shadow: none;
}

.submit-button.secondary:hover:not(:disabled) {
  background: var(--bg-secondary); /* Very light gray background on hover */
  border-color: var(--text-secondary); /* Medium gray border on hover */
  color: var(--text-primary); /* Keep dark text */
  box-shadow: var(--shadow-lg); /* Add subtle shadow */
  transform: scale(1.03);
}

/* Spinner inside buttons */
.submit-button .spinner {
  border: 2px solid rgba(255, 255, 255, 0.5); /* Lighter border for contrast on primary */
  border-top-color: white;
}
.submit-button.secondary .spinner {
    border: 2px solid rgba(0, 0, 0, 0.2); /* Darker border for contrast on secondary */
    border-top-color: var(--text-primary); /* Dark top */
}

/* Layout for buttons in panels */
.panel-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.5rem;
  gap: 1.5rem;
}
.panel-actions.simplified {
  justify-content: center;
}
.panel-actions.center {
  justify-content: center;
}
.button-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.instruction-info-box {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: var(--bg-accent-light); /* Light red tint background */
  border: 1px solid var(--border-accent); /* Light red border */
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.info-icon {
  font-size: 1.5rem; /* Keep size */
  color: var(--warning-color); /* Use warning color (amber) for icon */
  flex-shrink: 0;
  margin-top: 2px; /* Adjust vertical alignment slightly */
}

.info-content strong {
  color: var(--text-primary); /* Dark text for heading */
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600; /* Make heading bolder */
}

.info-content p {
  color: var(--text-secondary); /* Medium gray text */
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
  text-align: left;
}

.examples-section {
  margin-bottom: 2rem;
}

.examples-toggle {
  background: transparent;
  border: 1px solid var(--border-primary); /* Light gray border */
  color: var(--text-secondary); /* Medium gray text */
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 0.95rem;
  font-weight: 500; /* Add medium weight */
  transition: all 0.3s ease;
}

.examples-toggle:hover {
  background: var(--bg-secondary); /* Very light gray background */
  border-color: var(--text-secondary); /* Medium gray border */
  color: var(--text-primary); /* Dark text */
}

.arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  margin-left: 0.5rem;
}

.arrow.up {
  transform: rotate(180deg);
}

.examples-list {
  margin-top: 1rem;
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: 12px;
  padding: 1rem;
  background: var(--bg-secondary); /* Very light gray background */
  animation: slideDown 0.3s ease;
}

.example-item {
  padding: 1rem;
  margin-bottom: 0.75rem;
  background: var(--bg-primary); /* White background */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-secondary); /* Medium gray text */
  font-size: 0.95rem;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.example-item:last-child {
  margin-bottom: 0;
}

.example-item:hover {
  background: var(--bg-accent-light); /* Light red tint background */
  border-color: var(--text-accent); /* Red border */
  transform: translateX(5px);
  color: var(--text-primary); /* Dark text */
}

.example-icon {
  color: var(--text-accent); /* Red icon */
  flex-shrink: 0;
  font-weight: bold;
}

/* Ensure animation exists */
@keyframes slideDown {
  from { opacity: 0; max-height: 0; }
  to { opacity: 1; max-height: 500px; /* Adjust if needed */ }
}

/* Responsive adjustments for buttons in panels */
@media (max-width: 768px) {
    .panel-actions {
        flex-direction: column;
        gap: 1rem;
    }
    .panel-actions .submit-button {
        width: 100%; /* Make buttons full width on mobile */
        max-width: 350px; /* Optional: limit max width */
        margin-left: auto;
        margin-right: auto;
    }
}

.workbench-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.workbench-header h1 {
  color: var(--text-primary); /* Dark text */
  font-size: clamp(2.5rem, 5vw, 3rem);
  margin-bottom: 1rem;
  font-weight: 600;
  line-height: 1.2;
}

.workbench-header p {
  color: var(--text-secondary); /* Medium gray text */
  font-size: clamp(1rem, 2vw, 1.2rem);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.workbench-content {
  max-width: 1000px;
  margin: 2rem auto 0;
}

.workbench-panel {
  background: var(--bg-primary); /* White */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: 20px;
  padding: 3rem;
  animation: fadeIn 0.5s ease-in-out;
  box-shadow: var(--shadow-xl); /* Adjusted shadow for light theme */
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
}

.workbench-panel::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-button); /* Red gradient */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.workbench-panel:hover::before {
  opacity: 1;
}

.workbench-panel h3 {
  color: var(--text-primary); /* Dark text */
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.workbench-panel p {
  text-align: center;
  color: var(--text-secondary); /* Medium gray text */
  margin-bottom: 2rem;
  line-height: 1.6;
  font-size: 1.05rem;
}

/* Stepper Component - Adjusted for light theme */
.stepper-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto 3rem;
  padding: 2rem 0;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: var(--text-secondary); /* Medium gray text */
  transition: all 0.3s ease;
}

.step-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid var(--border-primary); /* Light gray border */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  transition: all 0.3s ease;
  background: var(--bg-secondary); /* Very light gray */
  color: var(--text-secondary); /* Medium gray text */
  font-size: 1.2rem;
}

.step-label {
  margin-top: 0.75rem;
  font-size: 0.95rem;
  font-weight: 500;
}

.step-item.active {
  color: var(--text-accent); /* Red text */
}

.step-item.active .step-number {
  background: var(--text-accent); /* Red background */
  color: var(--text-on-gradient); /* White text */
  border-color: var(--text-accent); /* Red border */
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.2); /* Red ring */
  transform: scale(1.1);
}

.step-connector {
  flex: 1 1;
  height: 3px;
  background: var(--border-primary); /* Light gray connector */
  margin: 0 1.5rem;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.step-connector.active {
  background: var(--text-accent); /* Red connector */
  box-shadow: 0 0 8px rgba(220, 38, 38, 0.3); /* Red glow */
}

/* Enhanced File Upload Zone - Light Theme */
.file-drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  border: 2px dashed var(--border-primary); /* Light gray dashed */
  border-radius: 16px;
  background: var(--bg-secondary); /* Very light gray */
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-secondary); /* Medium gray text */
  position: relative;
  overflow: hidden;
  min-height: 220px;
}

.file-drop-zone::before { /* Red glow effect */
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg,
    transparent,
    rgba(220, 38, 38, 0.05),
    transparent);
  transform: rotate(45deg);
  animation: fileGlow 3s infinite;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.file-drop-zone:hover {
  border-color: var(--text-accent); /* Red border */
  background: var(--bg-accent-light); /* Light red tint */
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.1); /* Reddish shadow */
}

.file-drop-zone:hover::before {
  opacity: 1;
}

.upload-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 1.5rem;
  color: var(--text-accent); /* Red icon */
  transition: all 0.3s ease;
}

.file-drop-zone:hover .upload-icon {
  transform: scale(1.1);
  color: var(--primary-red-dark); /* Darker red on hover */
}

.file-format-info {
  font-size: 0.9rem;
  margin-top: 0.75rem;
  color: var(--text-secondary); /* Medium gray text */
  text-align: center;
}

/* Resume Preview Card - Light Theme */
.resume-preview-card {
  padding: 2rem;
  background: var(--bg-secondary); /* Very light gray */
  border-radius: 16px;
  margin-bottom: 1.5rem;
  text-align: center;
  color: var(--text-primary); /* Dark text */
  font-weight: 500;
  border: 1px solid var(--border-primary); /* Light gray border */
  transition: all 0.3s ease;
  position: relative;
}

.resume-preview-card::before { /* Green checkmark */
  content: '✓';
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  background: var(--success-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  border: 3px solid var(--bg-secondary); /* Match card background */
}

.resume-preview-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); /* Lighter shadow */
  border-color: var(--text-accent); /* Red border */
}

/* Job Description Textarea - Light Theme */
.jd-textarea {
  width: 100%;
  padding: 2rem;
  border: 2px solid var(--border-primary); /* Light gray border */
  border-radius: 16px;
  background: var(--bg-primary); /* White background */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  min-height: 220px;
  transition: all 0.3s ease;
  line-height: 1.6;
}

.jd-textarea:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border */
  background: var(--bg-primary); /* Keep white background */
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1); /* Red ring */
}

.jd-textarea::placeholder {
  color: #9CA3AF; /* gray-400 */
}

/* Panel Actions - Buttons already use light theme styles from App.css/Auth.css */
.panel-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.5rem;
  gap: 1.5rem;
}

.panel-actions.simplified {
  justify-content: center;
  gap: 2rem;
}

/* Results Panel - Light Theme */
.results-panel {
  text-align: center;
  padding: 3rem 0;
}

.results-icon { /* Red gradient icon */
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--gradient-button);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  font-weight: bold;
  margin: 0 auto 2rem;
  box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3); /* Reddish shadow */
  animation: successPulse 2s ease-in-out infinite;
  position: relative;
}

.results-icon::after { /* Red glow */
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  background: var(--gradient-button);
  opacity: 0.3;
  z-index: -1;
  animation: iconGlow 2s ease-in-out infinite;
}

/* Enhanced Messages - Use light theme error/success styles */
.error-message {
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1.5rem 0;
  text-align: center;
  animation: messageSlide 0.3s ease;
  background: var(--error-bg-light); /* Light red tint */
  color: var(--error-color); /* Red text */
  border: 1px solid var(--border-accent); /* Light red border */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}
.error-message::before { content: '⚠'; font-size: 1.2rem; flex-shrink: 0; }
.error-message.main-error { max-width: 900px; margin: 1.5rem auto; }

.success-message {
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1.5rem 0;
  text-align: center;
  animation: messageSlide 0.3s ease;
  background: var(--success-bg-light); /* Light green tint */
  color: var(--success-color); /* Green text */
  border: 1px solid #A7F3D0; /* Light green border */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}
.success-message::before { content: '✓'; font-size: 1.2rem; flex-shrink: 0; }

/* Spinner */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.7); /* White border on button */
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-large { /* Spinner for loading states on page */
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: var(--text-accent); /* Red top border */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 1rem auto;
}

/* Add remaining styles from ResumeEnhancement.css, adjusting colors as needed */
/* Examples Section, Instructions Textarea, Character Count, etc. */

.instructions-textarea {
  width: 100%;
  padding: 1.5rem;
  border: 2px solid var(--border-primary);
  border-radius: 12px;
  background: var(--bg-primary); /* White */
  color: var(--text-primary); /* Dark text */
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  min-height: 200px;
  transition: all 0.3s ease;
  line-height: 1.6;
}
.instructions-textarea:focus {
  outline: none;
  border-color: var(--text-accent); /* Red border */
  background: var(--bg-primary);
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1); /* Red ring */
}
.instructions-textarea::placeholder {
  color: #9CA3AF; /* gray-400 */
}
.instructions-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--bg-secondary); /* Light gray disabled */
}

.character-count {
  text-align: right;
  font-size: 0.85rem;
  color: var(--text-secondary); /* Medium gray text */
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
}
.character-count .warning {
  color: var(--warning-color); /* Amber text */
  font-weight: 500;
}

/* Keep animations */
@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
@keyframes messageSlide { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes successPulse { 0%, 100% { transform: scale(1); box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3); } 50% { transform: scale(1.05); box-shadow: 0 15px 40px rgba(220, 38, 38, 0.4); } }
@keyframes iconGlow { 0%, 100% { opacity: 0.3; } 50% { opacity: 0.6; } }
@keyframes fileGlow { 0% { transform: translateX(-100%) rotate(45deg); } 100% { transform: translateX(100%) rotate(45deg); } }
@keyframes spin { to { transform: rotate(360deg); } }

/* Responsive Adjustments (Keep as is or adjust if needed) */
@media (max-width: 768px) {
  .workbench-panel { padding: 2rem; }
  .stepper-container { flex-direction: column; gap: 1.5rem; }
  .step-connector { display: none; }
  .file-drop-zone { padding: 2rem; min-height: 180px; }
  .panel-actions { flex-direction: column; gap: 1rem; }
  .panel-actions.simplified { flex-direction: column; }
  .submit-button { width: 100%; justify-content: center; }
}
@media (max-width: 480px) {
  .workbench-panel { padding: 1.5rem; }
  .workbench-header h1 { font-size: 2rem; }
  .results-icon { width: 80px; height: 80px; font-size: 2.5rem; }
  .jd-textarea { padding: 1.5rem; min-height: 180px; }
  .file-drop-zone { padding: 1.5rem; min-height: 150px; }
}

/* Modal styles for Instruction Prompt */
.modal-overlay { /* Keep dark overlay */
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
}
.modal-content {
  background: var(--bg-primary); /* White modal */
  border: 1px solid var(--border-primary); /* Light gray border */
  color: var(--text-primary); /* Dark text */
  box-shadow: var(--shadow-2xl); /* Standard shadow */
}
.modal-content::before { /* Red gradient top border */
  background: var(--gradient-button);
}
.modal-icon {
  width: 60px; /* Reduced size */
  height: 60px; /* Reduced size */
  margin: 0 auto 1.5rem; /* Slightly reduced bottom margin */
  background: rgba(220, 38, 38, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--text-accent);
}
.customize-icon {
  width: 30px; /* Reduced size */
  height: 30px; /* Reduced size */
  color: var(--text-accent);
}

.modal-content h3 { color: var(--text-primary); }
.modal-content p { color: var(--text-secondary); }
.modal-subtitle { color: var(--text-secondary); }

/* Disclaimer Modal */
.disclaimer-modal-content { 
  text-align: left;
 }
 .disclaimer-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.4rem; /* Slightly smaller title */
  font-weight: 600; /* Bolder title */
  color: var(--warning-color); /* Amber/Warning color for title */
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-primary); /* Add separator line */
  padding-bottom: 1rem;
}

.disclaimer-title svg {
  color: var(--warning-color);
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.disclaimer-text {
  background: var(--bg-secondary); /* Very light gray background */
  border: 1px solid var(--border-primary); /* Light gray border */
  border-radius: 8px;
  padding: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--text-secondary); /* Medium gray text */
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 1.5rem; /* Add margin below text */
}
.disclaimer-agreement {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem; /* Spacing between checkbox and label */
  margin-bottom: 1rem; /* Spacing below agreement */
}

.disclaimer-agreement input[type="checkbox"] {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px; /* Align checkbox with text */
  accent-color: var(--text-accent); /* Red checkbox */
  cursor: pointer;
}

.disclaimer-agreement label {
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--text-primary); /* Dark text */
  cursor: pointer;
  padding-top: 1px; /* Align text baseline */
}

.disclaimer-note {
  font-size: 0.85rem;
  color: var(--text-secondary); /* Medium gray text */
  margin-top: 1.5rem;
  padding-left: 0;
  line-height: 1.5;
  text-align: left;
}
.disclaimer-modal-content .modal-actions {
  display: flex;
  justify-content: center; /* Center button(s) */
  margin-top: 2rem; /* More space above button */
  padding-top: 1.5rem; /* Space above button */
  border-top: 1px solid var(--border-primary); /* Separator line */
}

/* Ensure the button uses the primary style */
.disclaimer-modal-content .modal-actions .submit-button {
  /* Inherits primary styles from .submit-button */
  /* No need for .secondary class here */
  min-width: 200px; /* Give button a good width */
}

/* Style disabled button specifically */
.disclaimer-modal-content .modal-actions .submit-button:disabled {
  background: var(--border-primary); /* Gray background when disabled */
  color: var(--text-secondary); /* Gray text when disabled */
  cursor: not-allowed;
  opacity: 0.8;
  box-shadow: none;
  transform: none;
}
.credit-usage-notification {
  padding: 1rem;
  background: var(--bg-secondary); /* Light gray */
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg);
  margin: 1.5rem 0;
  text-align: center;
}
.credit-usage-notification p {
  margin: 0;
  line-height: 1.5;
  color: var(--text-secondary);
}
.credit-usage-notification p strong {
  color: var(--text-primary);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/ResumeEnhancement.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,6DAA6D;;AAE7D,kDAAkD;;AAElD;EACE,+CAA+C;EAC/C,gCAAgC;EAChC,iDAAiD;EACjD,iCAAiC;EACjC,8CAA8C;EAC9C,oBAAoB,EAAE,qCAAqC;AAC7D;;AAEA;EACE,kCAAkC,EAAE,iBAAiB;EACrD,8BAA8B,EAAE,eAAe;EAC/C,uBAAuB,EAAE,8BAA8B;EACvD,eAAe,EAAE,gCAAgC;EACjD,gBAAgB;EAChB,YAAY;EACZ,wCAAwC,EAAE,kBAAkB;EAC5D,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE,4BAA4B;EAChD,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,sCAAsC,EAAE,yBAAyB;EACjE,sBAAsB,EAAE,wBAAwB;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,uCAAuC,EAAE,sBAAsB;EAC/D,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B,EAAE,wCAAwC;EACzE,mCAAmC,EAAE,gCAAgC;EACrE,0BAA0B,EAAE,mBAAmB;EAC/C,4BAA4B,EAAE,sBAAsB;EACpD,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,0CAA0C,EAAE,2CAA2C;EACvF,uBAAuB;AACzB;AACA;IACI,oCAAoC,EAAE,4CAA4C;IAClF,qCAAqC,EAAE,aAAa;AACxD;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kCAAkC,EAAE,8BAA8B;EAClE,sCAAsC,EAAE,qBAAqB;EAC7D,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB,EAAE,cAAc;EACjC,2BAA2B,EAAE,uCAAuC;EACpE,cAAc;EACd,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,0BAA0B,EAAE,0BAA0B;EACtD,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB,EAAE,wBAAwB;AAC5C;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC,EAAE,sBAAsB;EAC/D,4BAA4B,EAAE,qBAAqB;EACnD,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,sBAAsB;EACxC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B,EAAE,+BAA+B;EAChE,mCAAmC,EAAE,uBAAuB;EAC5D,0BAA0B,EAAE,cAAc;AAC5C;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uCAAuC,EAAE,sBAAsB;EAC/D,mBAAmB;EACnB,aAAa;EACb,+BAA+B,EAAE,+BAA+B;EAChE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B,EAAE,qBAAqB;EACpD,uCAAuC,EAAE,sBAAsB;EAC/D,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC,EAAE,8BAA8B;EAClE,gCAAgC,EAAE,eAAe;EACjD,0BAA0B;EAC1B,0BAA0B,EAAE,cAAc;AAC5C;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,cAAc;EACd,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,OAAO,UAAU,EAAE,aAAa,EAAE;EAClC,KAAK,UAAU,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AAC7D;;AAEA,iDAAiD;AACjD;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,WAAW,EAAE,sCAAsC;QACnD,gBAAgB,EAAE,8BAA8B;QAChD,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B,EAAE,UAAU;EACzC,uCAAuC,EAAE,sBAAsB;EAC/D,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,4BAA4B,EAAE,oCAAoC;EAClE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kCAAkC,EAAE,iBAAiB;EACrD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC,EAAE,sBAAsB;EAC/D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B,EAAE,oBAAoB;EACrD,4BAA4B,EAAE,qBAAqB;EACnD,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,8BAA8B,EAAE,mBAAmB;EACnD,8BAA8B,EAAE,eAAe;EAC/C,gCAAgC,EAAE,eAAe;EACjD,4CAA4C,EAAE,aAAa;EAC3D,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iCAAiC,EAAE,yBAAyB;EAC5D,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B,EAAE,kBAAkB;EAClD,0CAA0C,EAAE,aAAa;AAC3D;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC,EAAE,sBAAsB;EAChE,mBAAmB;EACnB,+BAA+B,EAAE,oBAAoB;EACrD,eAAe;EACf,yBAAyB;EACzB,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B,oBAAoB;EAC5C,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;gBAGc;EACd,wBAAwB;EACxB,+BAA+B;EAC/B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC,EAAE,eAAe;EACjD,kCAAkC,EAAE,mBAAmB;EACvD,2BAA2B;EAC3B,6CAA6C,EAAE,mBAAmB;AACpE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB,EAAE,aAAa;EACxC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B,EAAE,wBAAwB;AAC1D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,+BAA+B,EAAE,oBAAoB;EACrD,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;EAChB,uCAAuC,EAAE,sBAAsB;EAC/D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,+BAA+B,oBAAoB;EACjD,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qCAAqC,EAAE,0BAA0B;AACnE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C,EAAE,mBAAmB;EAChE,gCAAgC,EAAE,eAAe;AACnD;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,aAAa;EACb,uCAAuC,EAAE,sBAAsB;EAC/D,mBAAmB;EACnB,6BAA6B,EAAE,qBAAqB;EACpD,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,eAAe;EACjD,6BAA6B,EAAE,0BAA0B;EACzD,4CAA4C,EAAE,aAAa;AAC7D;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gBAAgB,sBAAsB;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C,EAAE,mBAAmB;EACnE,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA,uBAAuB,aAAa;EAClC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,2CAA2C;AAC7C;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC,EAAE,mBAAmB;EACtD,yBAAyB,EAAE,aAAa;EACxC,sCAAsC,EAAE,qBAAqB;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA,yBAAyB,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC1E,4BAA4B,gBAAgB,EAAE,mBAAmB,EAAE;;AAEnE;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC,EAAE,qBAAqB;EAC1D,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,uBAAuB;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA,2BAA2B,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE5E,YAAY;AACZ;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C,EAAE,2BAA2B;EACvE,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,iBAAiB,uCAAuC;EACtD,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC,EAAE,mBAAmB;EACzD,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF,mEAAmE;;AAEnE;EACE,WAAW;EACX,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,6BAA6B,EAAE,UAAU;EACzC,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gCAAgC,EAAE,eAAe;EACjD,6BAA6B;EAC7B,4CAA4C,EAAE,aAAa;AAC7D;AACA;EACE,cAAc,EAAE,aAAa;AAC/B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B,EAAE,wBAAwB;AAC3D;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,2BAA2B,EAAE,eAAe;EAC5C,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB,oBAAoB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACnH,0BAA0B,OAAO,UAAU,EAAE,4BAA4B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAC1H,0BAA0B,WAAW,mBAAmB,EAAE,8CAA8C,EAAE,EAAE,MAAM,sBAAsB,EAAE,8CAA8C,EAAE,EAAE;AAC5L,sBAAsB,WAAW,YAAY,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;AACvE,sBAAsB,KAAK,0CAA0C,EAAE,EAAE,OAAO,yCAAyC,EAAE,EAAE;AAC7H,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,4DAA4D;AAC5D;EACE,mBAAmB,aAAa,EAAE;EAClC,qBAAqB,sBAAsB,EAAE,WAAW,EAAE;EAC1D,kBAAkB,aAAa,EAAE;EACjC,kBAAkB,aAAa,EAAE,iBAAiB,EAAE;EACpD,iBAAiB,sBAAsB,EAAE,SAAS,EAAE;EACpD,4BAA4B,sBAAsB,EAAE;EACpD,iBAAiB,WAAW,EAAE,uBAAuB,EAAE;AACzD;AACA;EACE,mBAAmB,eAAe,EAAE;EACpC,uBAAuB,eAAe,EAAE;EACxC,gBAAgB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EAC9D,eAAe,eAAe,EAAE,iBAAiB,EAAE;EACnD,kBAAkB,eAAe,EAAE,iBAAiB,EAAE;AACxD;;AAEA,wCAAwC;AACxC,iBAAiB,sBAAsB;EACrC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,6BAA6B,EAAE,gBAAgB;EAC/C,uCAAuC,EAAE,sBAAsB;EAC/D,0BAA0B,EAAE,cAAc;EAC1C,6BAA6B,EAAE,oBAAoB;AACrD;AACA,yBAAyB,4BAA4B;EACnD,kCAAkC;AACpC;AACA;EACE,WAAW,EAAE,iBAAiB;EAC9B,YAAY,EAAE,iBAAiB;EAC/B,qBAAqB,EAAE,mCAAmC;EAC1D,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,WAAW,EAAE,iBAAiB;EAC9B,YAAY,EAAE,iBAAiB;EAC/B,yBAAyB;AAC3B;;AAEA,oBAAoB,0BAA0B,EAAE;AAChD,mBAAmB,4BAA4B,EAAE;AACjD,kBAAkB,4BAA4B,EAAE;;AAEhD,qBAAqB;AACrB;EACE,gBAAgB;CACjB;CACA;EACC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB,EAAE,2BAA2B;EAC9C,gBAAgB,EAAE,iBAAiB;EACnC,2BAA2B,EAAE,kCAAkC;EAC/D,qBAAqB;EACrB,8CAA8C,EAAE,uBAAuB;EACvE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,+BAA+B,EAAE,+BAA+B;EAChE,uCAAuC,EAAE,sBAAsB;EAC/D,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B,EAAE,qBAAqB;EACnD,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB,EAAE,0BAA0B;AACnD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY,EAAE,uCAAuC;EACrD,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe,EAAE,6BAA6B;EAC9C,gCAAgC,EAAE,iBAAiB;EACnD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B,EAAE,cAAc;EAC1C,eAAe;EACf,gBAAgB,EAAE,wBAAwB;AAC5C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB,EAAE,qBAAqB;EAC9C,gBAAgB,EAAE,4BAA4B;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,2CAA2C,EAAE,mBAAmB;AAClE;;AAEA,6CAA6C;AAC7C;EACE,gDAAgD;EAChD,sCAAsC;EACtC,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA,uCAAuC;AACvC;EACE,iCAAiC,EAAE,kCAAkC;EACrE,4BAA4B,EAAE,4BAA4B;EAC1D,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,+BAA+B,EAAE,eAAe;EAChD,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":["/* ResumeEnhancement.css - UPDATED WITH LIGHT THEME */\n\n/* --- Add these Button Styles to ResumeEnhancement.css --- */\n\n/* Base style for primary buttons (Red Gradient) */\n\n.page-container {\n  /* Ensure the light theme gradient is applied */\n  background: var(--gradient-hero);\n  /* Keep other necessary styles like padding-top */\n  padding-top: var(--navbar-height);\n  min-height: calc(100vh - var(--navbar-height));\n  padding-bottom: 4rem; /* Ensure consistent bottom padding */\n}\n\n.submit-button {\n  background: var(--gradient-button); /* Red gradient */\n  color: var(--text-on-gradient); /* White text */\n  padding: 0.75rem 1.5rem; /* Match Auth button padding */\n  font-size: 1rem; /* Match Auth button font size */\n  font-weight: 600;\n  border: none;\n  border-radius: var(--border-radius-full); /* Fully rounded */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  text-align: center; /* Ensure text is centered */\n  min-width: 150px; /* Give buttons a minimum width */\n}\n\n.submit-button:hover:not(:disabled) {\n  box-shadow: var(--shadow-button-hover); /* Reddish hover shadow */\n  transform: scale(1.03); /* Slight scale effect */\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Secondary Button Style (Gray border, dark text) */\n.submit-button.secondary {\n  background: transparent;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  color: var(--text-primary); /* Dark text */\n  box-shadow: none;\n}\n\n.submit-button.secondary:hover:not(:disabled) {\n  background: var(--bg-secondary); /* Very light gray background on hover */\n  border-color: var(--text-secondary); /* Medium gray border on hover */\n  color: var(--text-primary); /* Keep dark text */\n  box-shadow: var(--shadow-lg); /* Add subtle shadow */\n  transform: scale(1.03);\n}\n\n/* Spinner inside buttons */\n.submit-button .spinner {\n  border: 2px solid rgba(255, 255, 255, 0.5); /* Lighter border for contrast on primary */\n  border-top-color: white;\n}\n.submit-button.secondary .spinner {\n    border: 2px solid rgba(0, 0, 0, 0.2); /* Darker border for contrast on secondary */\n    border-top-color: var(--text-primary); /* Dark top */\n}\n\n/* Layout for buttons in panels */\n.panel-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 2.5rem;\n  gap: 1.5rem;\n}\n.panel-actions.simplified {\n  justify-content: center;\n}\n.panel-actions.center {\n  justify-content: center;\n}\n.button-group {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.instruction-info-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  background: var(--bg-accent-light); /* Light red tint background */\n  border: 1px solid var(--border-accent); /* Light red border */\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.info-icon {\n  font-size: 1.5rem; /* Keep size */\n  color: var(--warning-color); /* Use warning color (amber) for icon */\n  flex-shrink: 0;\n  margin-top: 2px; /* Adjust vertical alignment slightly */\n}\n\n.info-content strong {\n  color: var(--text-primary); /* Dark text for heading */\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 1.1rem;\n  font-weight: 600; /* Make heading bolder */\n}\n\n.info-content p {\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin: 0;\n  text-align: left;\n}\n\n.examples-section {\n  margin-bottom: 2rem;\n}\n\n.examples-toggle {\n  background: transparent;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  color: var(--text-secondary); /* Medium gray text */\n  padding: 0.75rem 1.25rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 0.95rem;\n  font-weight: 500; /* Add medium weight */\n  transition: all 0.3s ease;\n}\n\n.examples-toggle:hover {\n  background: var(--bg-secondary); /* Very light gray background */\n  border-color: var(--text-secondary); /* Medium gray border */\n  color: var(--text-primary); /* Dark text */\n}\n\n.arrow {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  margin-left: 0.5rem;\n}\n\n.arrow.up {\n  transform: rotate(180deg);\n}\n\n.examples-list {\n  margin-top: 1rem;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: 12px;\n  padding: 1rem;\n  background: var(--bg-secondary); /* Very light gray background */\n  animation: slideDown 0.3s ease;\n}\n\n.example-item {\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  background: var(--bg-primary); /* White background */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: 0.95rem;\n  line-height: 1.5;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.example-item:last-child {\n  margin-bottom: 0;\n}\n\n.example-item:hover {\n  background: var(--bg-accent-light); /* Light red tint background */\n  border-color: var(--text-accent); /* Red border */\n  transform: translateX(5px);\n  color: var(--text-primary); /* Dark text */\n}\n\n.example-icon {\n  color: var(--text-accent); /* Red icon */\n  flex-shrink: 0;\n  font-weight: bold;\n}\n\n/* Ensure animation exists */\n@keyframes slideDown {\n  from { opacity: 0; max-height: 0; }\n  to { opacity: 1; max-height: 500px; /* Adjust if needed */ }\n}\n\n/* Responsive adjustments for buttons in panels */\n@media (max-width: 768px) {\n    .panel-actions {\n        flex-direction: column;\n        gap: 1rem;\n    }\n    .panel-actions .submit-button {\n        width: 100%; /* Make buttons full width on mobile */\n        max-width: 350px; /* Optional: limit max width */\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n.workbench-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n}\n\n.workbench-header h1 {\n  color: var(--text-primary); /* Dark text */\n  font-size: clamp(2.5rem, 5vw, 3rem);\n  margin-bottom: 1rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.workbench-header p {\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: clamp(1rem, 2vw, 1.2rem);\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.workbench-content {\n  max-width: 1000px;\n  margin: 2rem auto 0;\n}\n\n.workbench-panel {\n  background: var(--bg-primary); /* White */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: 20px;\n  padding: 3rem;\n  animation: fadeIn 0.5s ease-in-out;\n  box-shadow: var(--shadow-xl); /* Adjusted shadow for light theme */\n  margin-bottom: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.workbench-panel::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-button); /* Red gradient */\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.workbench-panel:hover::before {\n  opacity: 1;\n}\n\n.workbench-panel h3 {\n  color: var(--text-primary); /* Dark text */\n  font-size: 1.8rem;\n  text-align: center;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.workbench-panel p {\n  text-align: center;\n  color: var(--text-secondary); /* Medium gray text */\n  margin-bottom: 2rem;\n  line-height: 1.6;\n  font-size: 1.05rem;\n}\n\n/* Stepper Component - Adjusted for light theme */\n.stepper-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  padding: 2rem 0;\n}\n\n.step-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  color: var(--text-secondary); /* Medium gray text */\n  transition: all 0.3s ease;\n}\n\n.step-number {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border: 2px solid var(--border-primary); /* Light gray border */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  background: var(--bg-secondary); /* Very light gray */\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: 1.2rem;\n}\n\n.step-label {\n  margin-top: 0.75rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.step-item.active {\n  color: var(--text-accent); /* Red text */\n}\n\n.step-item.active .step-number {\n  background: var(--text-accent); /* Red background */\n  color: var(--text-on-gradient); /* White text */\n  border-color: var(--text-accent); /* Red border */\n  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.2); /* Red ring */\n  transform: scale(1.1);\n}\n\n.step-connector {\n  flex: 1;\n  height: 3px;\n  background: var(--border-primary); /* Light gray connector */\n  margin: 0 1.5rem;\n  margin-bottom: 1.5rem;\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n.step-connector.active {\n  background: var(--text-accent); /* Red connector */\n  box-shadow: 0 0 8px rgba(220, 38, 38, 0.3); /* Red glow */\n}\n\n/* Enhanced File Upload Zone - Light Theme */\n.file-drop-zone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  border: 2px dashed var(--border-primary); /* Light gray dashed */\n  border-radius: 16px;\n  background: var(--bg-secondary); /* Very light gray */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-secondary); /* Medium gray text */\n  position: relative;\n  overflow: hidden;\n  min-height: 220px;\n}\n\n.file-drop-zone::before { /* Red glow effect */\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(45deg,\n    transparent,\n    rgba(220, 38, 38, 0.05),\n    transparent);\n  transform: rotate(45deg);\n  animation: fileGlow 3s infinite;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.file-drop-zone:hover {\n  border-color: var(--text-accent); /* Red border */\n  background: var(--bg-accent-light); /* Light red tint */\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.1); /* Reddish shadow */\n}\n\n.file-drop-zone:hover::before {\n  opacity: 1;\n}\n\n.upload-icon {\n  width: 60px;\n  height: 60px;\n  margin-bottom: 1.5rem;\n  color: var(--text-accent); /* Red icon */\n  transition: all 0.3s ease;\n}\n\n.file-drop-zone:hover .upload-icon {\n  transform: scale(1.1);\n  color: var(--primary-red-dark); /* Darker red on hover */\n}\n\n.file-format-info {\n  font-size: 0.9rem;\n  margin-top: 0.75rem;\n  color: var(--text-secondary); /* Medium gray text */\n  text-align: center;\n}\n\n/* Resume Preview Card - Light Theme */\n.resume-preview-card {\n  padding: 2rem;\n  background: var(--bg-secondary); /* Very light gray */\n  border-radius: 16px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  color: var(--text-primary); /* Dark text */\n  font-weight: 500;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.resume-preview-card::before { /* Green checkmark */\n  content: '✓';\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 30px;\n  height: 30px;\n  background: var(--success-color);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 700;\n  border: 3px solid var(--bg-secondary); /* Match card background */\n}\n\n.resume-preview-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); /* Lighter shadow */\n  border-color: var(--text-accent); /* Red border */\n}\n\n/* Job Description Textarea - Light Theme */\n.jd-textarea {\n  width: 100%;\n  padding: 2rem;\n  border: 2px solid var(--border-primary); /* Light gray border */\n  border-radius: 16px;\n  background: var(--bg-primary); /* White background */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 220px;\n  transition: all 0.3s ease;\n  line-height: 1.6;\n}\n\n.jd-textarea:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border */\n  background: var(--bg-primary); /* Keep white background */\n  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1); /* Red ring */\n}\n\n.jd-textarea::placeholder {\n  color: #9CA3AF; /* gray-400 */\n}\n\n/* Panel Actions - Buttons already use light theme styles from App.css/Auth.css */\n.panel-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 2.5rem;\n  gap: 1.5rem;\n}\n\n.panel-actions.simplified {\n  justify-content: center;\n  gap: 2rem;\n}\n\n/* Results Panel - Light Theme */\n.results-panel {\n  text-align: center;\n  padding: 3rem 0;\n}\n\n.results-icon { /* Red gradient icon */\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: var(--gradient-button);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: bold;\n  margin: 0 auto 2rem;\n  box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3); /* Reddish shadow */\n  animation: successPulse 2s ease-in-out infinite;\n  position: relative;\n}\n\n.results-icon::after { /* Red glow */\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border-radius: 50%;\n  background: var(--gradient-button);\n  opacity: 0.3;\n  z-index: -1;\n  animation: iconGlow 2s ease-in-out infinite;\n}\n\n/* Enhanced Messages - Use light theme error/success styles */\n.error-message {\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin: 1.5rem 0;\n  text-align: center;\n  animation: messageSlide 0.3s ease;\n  background: var(--error-bg-light); /* Light red tint */\n  color: var(--error-color); /* Red text */\n  border: 1px solid var(--border-accent); /* Light red border */\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n}\n.error-message::before { content: '⚠'; font-size: 1.2rem; flex-shrink: 0; }\n.error-message.main-error { max-width: 900px; margin: 1.5rem auto; }\n\n.success-message {\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin: 1.5rem 0;\n  text-align: center;\n  animation: messageSlide 0.3s ease;\n  background: var(--success-bg-light); /* Light green tint */\n  color: var(--success-color); /* Green text */\n  border: 1px solid #A7F3D0; /* Light green border */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n}\n.success-message::before { content: '✓'; font-size: 1.2rem; flex-shrink: 0; }\n\n/* Spinner */\n.spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.7); /* White border on button */\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.spinner-large { /* Spinner for loading states on page */\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top-color: var(--text-accent); /* Red top border */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 1rem auto;\n}\n\n/* Add remaining styles from ResumeEnhancement.css, adjusting colors as needed */\n/* Examples Section, Instructions Textarea, Character Count, etc. */\n\n.instructions-textarea {\n  width: 100%;\n  padding: 1.5rem;\n  border: 2px solid var(--border-primary);\n  border-radius: 12px;\n  background: var(--bg-primary); /* White */\n  color: var(--text-primary); /* Dark text */\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 200px;\n  transition: all 0.3s ease;\n  line-height: 1.6;\n}\n.instructions-textarea:focus {\n  outline: none;\n  border-color: var(--text-accent); /* Red border */\n  background: var(--bg-primary);\n  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1); /* Red ring */\n}\n.instructions-textarea::placeholder {\n  color: #9CA3AF; /* gray-400 */\n}\n.instructions-textarea:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: var(--bg-secondary); /* Light gray disabled */\n}\n\n.character-count {\n  text-align: right;\n  font-size: 0.85rem;\n  color: var(--text-secondary); /* Medium gray text */\n  margin-top: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n.character-count .warning {\n  color: var(--warning-color); /* Amber text */\n  font-weight: 500;\n}\n\n/* Keep animations */\n@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes messageSlide { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes successPulse { 0%, 100% { transform: scale(1); box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3); } 50% { transform: scale(1.05); box-shadow: 0 15px 40px rgba(220, 38, 38, 0.4); } }\n@keyframes iconGlow { 0%, 100% { opacity: 0.3; } 50% { opacity: 0.6; } }\n@keyframes fileGlow { 0% { transform: translateX(-100%) rotate(45deg); } 100% { transform: translateX(100%) rotate(45deg); } }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* Responsive Adjustments (Keep as is or adjust if needed) */\n@media (max-width: 768px) {\n  .workbench-panel { padding: 2rem; }\n  .stepper-container { flex-direction: column; gap: 1.5rem; }\n  .step-connector { display: none; }\n  .file-drop-zone { padding: 2rem; min-height: 180px; }\n  .panel-actions { flex-direction: column; gap: 1rem; }\n  .panel-actions.simplified { flex-direction: column; }\n  .submit-button { width: 100%; justify-content: center; }\n}\n@media (max-width: 480px) {\n  .workbench-panel { padding: 1.5rem; }\n  .workbench-header h1 { font-size: 2rem; }\n  .results-icon { width: 80px; height: 80px; font-size: 2.5rem; }\n  .jd-textarea { padding: 1.5rem; min-height: 180px; }\n  .file-drop-zone { padding: 1.5rem; min-height: 150px; }\n}\n\n/* Modal styles for Instruction Prompt */\n.modal-overlay { /* Keep dark overlay */\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(5px);\n}\n.modal-content {\n  background: var(--bg-primary); /* White modal */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  color: var(--text-primary); /* Dark text */\n  box-shadow: var(--shadow-2xl); /* Standard shadow */\n}\n.modal-content::before { /* Red gradient top border */\n  background: var(--gradient-button);\n}\n.modal-icon {\n  width: 60px; /* Reduced size */\n  height: 60px; /* Reduced size */\n  margin: 0 auto 1.5rem; /* Slightly reduced bottom margin */\n  background: rgba(220, 38, 38, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--text-accent);\n}\n.customize-icon {\n  width: 30px; /* Reduced size */\n  height: 30px; /* Reduced size */\n  color: var(--text-accent);\n}\n\n.modal-content h3 { color: var(--text-primary); }\n.modal-content p { color: var(--text-secondary); }\n.modal-subtitle { color: var(--text-secondary); }\n\n/* Disclaimer Modal */\n.disclaimer-modal-content { \n  text-align: left;\n }\n .disclaimer-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.4rem; /* Slightly smaller title */\n  font-weight: 600; /* Bolder title */\n  color: var(--warning-color); /* Amber/Warning color for title */\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid var(--border-primary); /* Add separator line */\n  padding-bottom: 1rem;\n}\n\n.disclaimer-title svg {\n  color: var(--warning-color);\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n.disclaimer-text {\n  background: var(--bg-secondary); /* Very light gray background */\n  border: 1px solid var(--border-primary); /* Light gray border */\n  border-radius: 8px;\n  padding: 1.5rem;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: var(--text-secondary); /* Medium gray text */\n  max-height: 200px;\n  overflow-y: auto;\n  margin-bottom: 1.5rem; /* Add margin below text */\n}\n.disclaimer-agreement {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem; /* Spacing between checkbox and label */\n  margin-bottom: 1rem; /* Spacing below agreement */\n}\n\n.disclaimer-agreement input[type=\"checkbox\"] {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  margin-top: 2px; /* Align checkbox with text */\n  accent-color: var(--text-accent); /* Red checkbox */\n  cursor: pointer;\n}\n\n.disclaimer-agreement label {\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--text-primary); /* Dark text */\n  cursor: pointer;\n  padding-top: 1px; /* Align text baseline */\n}\n\n.disclaimer-note {\n  font-size: 0.85rem;\n  color: var(--text-secondary); /* Medium gray text */\n  margin-top: 1.5rem;\n  padding-left: 0;\n  line-height: 1.5;\n  text-align: left;\n}\n.disclaimer-modal-content .modal-actions {\n  display: flex;\n  justify-content: center; /* Center button(s) */\n  margin-top: 2rem; /* More space above button */\n  padding-top: 1.5rem; /* Space above button */\n  border-top: 1px solid var(--border-primary); /* Separator line */\n}\n\n/* Ensure the button uses the primary style */\n.disclaimer-modal-content .modal-actions .submit-button {\n  /* Inherits primary styles from .submit-button */\n  /* No need for .secondary class here */\n  min-width: 200px; /* Give button a good width */\n}\n\n/* Style disabled button specifically */\n.disclaimer-modal-content .modal-actions .submit-button:disabled {\n  background: var(--border-primary); /* Gray background when disabled */\n  color: var(--text-secondary); /* Gray text when disabled */\n  cursor: not-allowed;\n  opacity: 0.8;\n  box-shadow: none;\n  transform: none;\n}\n.credit-usage-notification {\n  padding: 1rem;\n  background: var(--bg-secondary); /* Light gray */\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-lg);\n  margin: 1.5rem 0;\n  text-align: center;\n}\n.credit-usage-notification p {\n  margin: 0;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n.credit-usage-notification p strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
